// Mock data for AskTech Solution website

export const companyInfo = {
  name: "AskTech Solutions",
  tagline: "Transforming Ideas into Digital Reality",
  description: "We are a cutting-edge technology consultancy specializing in AI, software development, and digital transformation. Our team of experts helps businesses leverage technology to achieve their goals.",
  email: "asktechnologypvtltd@gmail.com",
  phone: "+91-9082149472",
  whatsapp: "919082149472",
  address: "Mumbai, India"
};

export const services = [
  {
    id: 1,
    title: "AI Agent Development",
    description: "Build intelligent AI agents that automate complex tasks, enhance customer interactions, and drive operational efficiency across your organization.",
    icon: "Bot"
  },
  {
    id: 2,
    title: "LLM Deployment in Workflow",
    description: "Seamlessly integrate Large Language Models into your existing workflows to unlock powerful automation and intelligent decision-making capabilities.",
    icon: "Brain"
  },
  {
    id: 3,
    title: "Full Stack Development",
    description: "End-to-end software development services using modern technologies to build scalable, secure, and high-performance applications.",
    icon: "Code"
  },
  {
    id: 4,
    title: "Mobile App Development",
    description: "Native and cross-platform mobile applications that deliver exceptional user experiences on iOS and Android devices.",
    icon: "Smartphone"
  },
  {
    id: 5,
    title: "Ecommerce Website Development",
    description: "Complete e-commerce solutions including Shopify, WooCommerce, and custom hosted platforms. We build online stores that convert visitors into customers.",
    icon: "ShoppingCart"
  },
  {
    id: 6,
    title: "ERP Implementation",
    description: "Strategic ERP solutions that streamline operations, improve visibility, and enable data-driven decision making.",
    icon: "Database"
  },
  {
    id: 7,
    title: "WMS Implementation",
    description: "Warehouse Management System solutions that optimize inventory control, streamline picking and packing, and enhance warehouse operations efficiency.",
    icon: "Warehouse"
  },
  {
    id: 8,
    title: "AWS Cloud Services",
    description: "Comprehensive AWS solutions including cloud migration, infrastructure setup, serverless architecture, and managed cloud services for scalable applications.",
    icon: "Cloud"
  },
  {
    id: 9,
    title: "Supply Chain Digitization",
    description: "Transform your supply chain with digital solutions that optimize logistics, reduce costs, and improve transparency.",
    icon: "Network"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Technology Director",
    role: "Enterprise Client",
    content: "AskTech Solutions transformed our operations with their AI solutions. The results exceeded our expectations.",
    avatar: "TD"
  },
  {
    id: 2,
    name: "Business Owner",
    role: "E-commerce Client",
    content: "Their e-commerce expertise helped us triple our online revenue within 6 months. Highly recommended!",
    avatar: "BO"
  },
  {
    id: 3,
    name: "Operations Head",
    role: "Manufacturing Client",
    content: "The supply chain digitization project delivered ROI within the first quarter. Exceptional work.",
    avatar: "OH"
  }
];

export const partners = [
  {
    name: "Zoho",
    logo: "https://www.zoho.com/branding/images/zoho-logo-512px.png"
  },
  {
    name: "AWS",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg"
  },
  {
    name: "Shopify",
    logo: "https://cdn.worldvectorlogo.com/logos/shopify.svg"
  }
];

export const stats = [
  { value: "150+", label: "Projects Delivered" },
  { value: "50+", label: "Enterprise Clients" },
  { value: "98%", label: "Client Satisfaction" },
  { value: "24/7", label: "Support Available" }
];

export const demoSlots = [
  { id: 1, time: "09:00 AM", available: true },
  { id: 2, time: "10:00 AM", available: true },
  { id: 3, time: "11:00 AM", available: false },
  { id: 4, time: "02:00 PM", available: true },
  { id: 5, time: "03:00 PM", available: true },
  { id: 6, time: "04:00 PM", available: true }
];
